import makeApiCall from "./master/axiosIndex";
export const calendarApis = {
  createCalendar: (data: any): Promise<any> => {
    return makeApiCall({
      url: "/calendar/create",
      method: "post",
      data,
    });
  },
  listCalendars: (data: any): Promise<any> => {
    return makeApiCall({
      url: "/calendar/list",
      method: "get",
      params: data,
    });
  },
  getCalendarById: (calendarId: string): Promise<any> => {
    return makeApiCall({
      url: `/calendar/id/${calendarId}`,
      method: "get",
    });
  },
  updateCalendar: (data: any): Promise<any> => {
    return makeApiCall({
      url: `/calendar/update`,
      method: "put",
      data,
    });
  },
  inactivateCalendar: (calendarId: string): Promise<any> => {
    return makeApiCall({
      url: `/calendar/inactivate/${calendarId}`,
      method: "patch",
    });
  },
  activateCalendar: (calendarId: string): Promise<any> => {
    return makeApiCall({
      url: `/calendar/activate/${calendarId}`,
      method: "patch",
    });
  },
};
